import { Component, OnInit, OnDestroy } from '@angular/core';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StorageService } from '../../../shared/security/StorageService';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { SeverEmploymentService } from '../sever-employment.service';
import { EntityLicenseModel } from '../../../model/entityLicenseModel';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-start-sever-employment',
  templateUrl: './start-sever-employment.component.html',
  styleUrls: ['./start-sever-employment.component.css']
})
export class StartSeverEmploymentComponent implements OnInit, OnDestroy{
 
  title: string ="";

  startFunction: StartFunctionResponseModel = {};
  userSessionId: number;
  employmentInfo:EntityLicenseModel;
  noCurrentEmployer:string="";

  constructor(private startFunctionService: StartFunctionService,private currentPageWatcher: CurrentPageWatcherService,
    private storage: StorageService, private severEmploymentService:SeverEmploymentService,private router:Router,
    private spinner: SpinnerService) { 
      this.startFunction = this.storage.getStartFunctionData();
    if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {
      this.title = this.startFunction.Workflow.WorkflowDisplayName;
      this.startFunctionService.sendStartFunctionBrokerResp(this.startFunction);
    }

      this.userSessionId = this.storage.getSessionData().userSessionId;
      this.severEmploymentService.getEmploymentInfo(this.userSessionId).subscribe(empInfoData => {
        console.log("empInfoData", empInfoData);
        this.employmentInfo = empInfoData;
       
      },
        err => {
          if (err.status == 404) {
            this.noCurrentEmployer = "No Employing Broker";
          this.spinner.hide();

          }
  
        } );
      }
    

  ngOnInit() {
    this.currentPageWatcher.pageChanged().emit(this.title);

  
}

startWorkFlow() {
  if (this.employmentInfo != null) {
    this.router.navigate(['/severEmploymentNotification']).then(() => {
      this.severEmploymentService.getNotifySeverEmploymentInformation().emit(this.employmentInfo);
      this.startFunctionService.getNotifyStepInProgress().emit(true);

    });
  } 
}
goBackHome() {
  this.router.navigate(['/home']);
}

ngOnDestroy(): void {
  //unsubscribe
  this.currentPageWatcher.clearUserMessage();
  this.currentPageWatcher.clearStepMessage();
}


}



// WEBPACK FOOTER //
// ./src/app/broker/sever-employment/start-server-employment/start-sever-employment.component.ts